/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import * as MODALS from "../modals";
import * as API from "../../http/api";
import { openlightbox } from "../../util/Functions";
import { useHistory } from "react-router-dom";
import "@9softstudio/react-monthpicker/dist/reactmonthpicker.css";
import moment from "moment";
import "moment/locale/es";
import * as FORMAT from "react-day-picker/moment";
import DayPickerInput from "react-day-picker/DayPickerInput";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DataTable from "react-data-table-component";
import { ThemeProvider } from "@mui/material/styles";
import { theme, customStyles2 } from "../../util/TableStyles"
import { noDataComponent } from "../../util/DataObject"

const LeadList = (props) => {
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(0);
  const [total, setTotal] = useState(0);
  const [totalPage, setTotalPage] = useState(50);
  const [list, setList] = useState([]);
  const [oldList, setOldList] = useState([]);
  const today = new Date();
  const [startDate, setStartDate] = useState(new Date());
  const [initialDate, setInitialDate] = useState(new Date());
  const [endingDate, setEndingDate] = useState(new Date());
  const [selectedDates, setSelectedDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [search, setSearch] = useState("");
  const [rolEdit, setRolEdit] = useState(false);
  const history = useHistory();

  useEffect(() => {
    init();
    if (props.widgets[0].config.actions.indexOf("edit") > -1) {
      setRolEdit(true);
    }
  }, [props.content]);

  moment.locale("es");
  const init = () => {
    setSearch("");
    if (props.content.start_date) {
      let dates = [];
      setStartDate(new Date(props.content.start_date));
      setSelectedDate(new Date(props.content.start_date));
      setInitialDate(new Date(props.content.start_date));
      dates.push(new Date(props.content.start_date));
      setSelectedDates(dates);
    }
    if (props.content.end_date) {
      setEndingDate(new Date(props.content.end_date));
    }
    if (props.content.result_per_page) {
      setTotalPage(props.content.result_per_page);
    }
    if (props.content.hasOwnProperty("totalPages")) {
      setPages(props.content.totalPages);
    }
    if (props.content.page_number) {
      setPage(props.content.page_number);
    }
    if (props.content.hasOwnProperty("total")) {
      setTotal(props.content.total);
    }
    if (props.content.leads) {
      setList(JSON.parse(JSON.stringify(props.content.leads)));
      setOldList(JSON.parse(JSON.stringify(props.content.leads)));
    }
  };

  const changeDay = async (date) => {
    let initString = date.toJSON().substring(0, 10);
    let initial = new Date(initString);
    let timeZone = moment(initial.toJSON().substring(0, 10)).tz("America/Mexico_City").toJSON();
    let end = new Date(date.getTime() + 1000 * 3600 * 24);
    let timeZoneEnd = moment(end.toJSON().substring(0, 10)).tz("America/Mexico_City").toJSON();

    let data = {
      page_number: 1,
      result_per_page: totalPage,
      start_date: timeZone,
      end_date: timeZoneEnd,
    };

    await requestLeads(data);
  };

  const changePage = async (type) => {
    let p = page;
    if (type == "next") {
      p = p + 1;
    }
    if (type == "prev") {
      p = p - 1;
    }
    let data = {
      page_number: p,
      result_per_page: totalPage,
      start_date: initialDate.toJSON(),
      end_date: endingDate.toJSON(),
    };

    await requestLeads(data);
  };

  const requestLeads = async (data) => {
    props.changeLoader(true);
    let dataRequest = {
      data: data,
    };

    let request = await API.service("leadList", dataRequest, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.status == 200) {
      if (request.data.data.response == "OK") {
        let widg = [];
        widg = request.data.data.widget;
        props.changeWidgets(request.data.data.widget);
      }
    }
    props.changeLoader(false);
  };

  const getLead = async (item) => {
    props.changeLoader(true);
    let dataRequest = {
      uuid: item.uuid,
    };
    let request = await API.service( "leadInfo", dataRequest, props.pos, props.changeAlert, props.changeLoader, history);

    if (request.status == 200) {
      if (request.data.data.response == "OK") {
        let widg = request.data.data.widget;
        if (widg[0]?.type === "leadInfo") {
          const as = (
            <MODALS.LeadInfo
              contentModal={widg[0].content}
              pos={props.pos}
              rolEdit={rolEdit}
              changeAlert={props.changeAlert}
              changeLoader={props.changeLoader}
              catalogs={props.catalogs}
              history={history}
              updateLead={updateLead}
              key="leadInfo"
            />
          );
          openlightbox(as);
        }
      }
    }
    props.changeLoader(false);
  };

  const changeText = (e) => {
    setSearch(e.target.value);
    filter(e.target.value);
  };

  const filter = (filter) => {
    let old = oldList;
    let l = list;
    if (!filter) {
      setList(JSON.parse(JSON.stringify(oldList)));
    } else {
      let newList = [];
      for (let i = 0; i < old.length; i++) {
        if (
          (old[i]["name"] && old[i]["name"].toLowerCase().indexOf(filter.toLowerCase()) > -1) ||
          (old[i]["email"] && old[i]["email"].toLowerCase().indexOf(filter.toLowerCase()) > -1) ||
          (old[i]["phone"] && old[i]["phone"].toLowerCase().indexOf(filter.toLowerCase()) > -1)
        ) {
          newList.push(old[i]);
        }
      }
      setList(JSON.parse(JSON.stringify(newList)));
    }
  };

  const updateLead = async (data, funcClose) => {
    props.changeLoader(true);
    let request = await API.service( "updateLead", data, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.status == 200) {
      if (request.data.data.response == "OK") {
        let dataList = {
          page_number: 1,
          result_per_page: 50,
          start_date: initialDate.toJSON(),
          end_date: endingDate.toJSON(),
        };

        await requestLeads(dataList);
        funcClose();
      }
    }
    props.changeLoader(false);
  };

  const deleteLead = async (uuid) => {
    props.changeLoader(true);
    let data = {
      uuid: uuid,
    };
    let request = await API.service( "deletedLead", data, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.status == 200) {
      if (request.data.data.response == "OK") {
        let dataList = {
          page_number: 1,
          result_per_page: 50,
          start_date: initialDate.toJSON(),
          end_date: endingDate.toJSON(),
        };
        props.changeAlert(true, "success", "El lead se borro correctamente");
        await requestLeads(dataList);
      }
    }
    props.changeLoader(false);
  };

  const columns = [];
  if (list) {
    columns.push(
      { selector: (row) => row.name, name: "Nombre", width:"22%", wrap: true, sortable: true },
      { selector: (row) => row.email, name: "Email", width:"25%", wrap: true, sortable: true },
      { selector: (row) => row.phone, name: "Teléfono", width:"14%", sortable: true },
      { selector: (row) => row.score.score +"%", name: "Score", width:"7%", sortable: true },
      { selector: (row) => moment(row.cdate).format("LLL"), name: "Fecha de creación", width:"22%", sortable: true },
    )
  }
  if (rolEdit) {
    columns.push({
      cell: (row) => {
        return (
          <div style={{display: "flex"}}>
            <i className="ibon-edit tap inb2 col-2" style={{marginRight: "15px"}}
              onClick={getLead.bind(this, row)} />
            <i className="ibon-delete tap inb2 col-2"
              onClick={deleteLead.bind(this, row.uuid)} />
          </div>
        )},
      width: "8%", sortable: true,
    });
  }
  if (!rolEdit) {
    columns.push({
      cell: (row) => {
        return (
          <a onClick={getLead.bind(this, row)}>
            <VisibilityIcon />
          </a>
        );
      },
      width: "8%", sortable: true,
    });
  }

  return (
    <div className="size-12">
      <div className="tabBox card dataBlock">
        <div className="form-row">
          <div className="col-ico">
            <i className="ibon-autodeposit inb4" />
          </div>
          <h2 className="col-4">Leads</h2>
          <div style={{ display: "flex", justifyContent: "right", width: "76%" }}>
            <DayPickerInput
              onDayChange={changeDay}
              placeholder="Inicio"
              format="DD-MM-YYYY"
              inputProps={{ readOnly: true }}
              value={selectedDate}
              formatDate={FORMAT.default.formatDate}
              parseDate={FORMAT.default.parseDate}
              dayPickerProps={{
                months: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
                fixedWeeks: false,
                pagedNavigation: true,
                numberOfMonths: 1,
                disabledDays: {after: today},
                selectedDays: selectedDates,
              }}
            />
            <div className="searchInput search-leadList">
              <input
                type="text"
                className="ibon-account"
                placeholder="Nombre, telefono, email"
                value={search}
                onChange={changeText.bind(this)}
              />
              <i className="ibon-search tap ibonSearch-leadList"></i>
            </div>
          </div>
        </div>

        <div className="tableToolspages fix-pag-tbl page-leadList">
          <span className="neutral">
            {list.length > 0 ? (page - 1) * totalPage + 1 : 0} -{" "}
            {totalPage * page <= total ? totalPage * page : total} de {total}
          </span>
          {page > 1 && (
            <i className="tap ibon-chevron-left indigo"
              onClick={changePage.bind(this, "prev")} />
          )}
          {page < pages && (
            <i className="tap ibon-chevron-right indigo"
              onClick={changePage.bind(this, "next")} />
          )}
        </div>
        <div style={{ width: "100%", margin: "auto" }}>
          <ThemeProvider theme={theme}>
            <DataTable
              columns={columns}
              data={list}
              customStyles={customStyles2}
              noDataComponent={noDataComponent}
            />
          </ThemeProvider>
        </div>
      </div>
    </div>
  );
};

export default LeadList;
